var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlantBadge = function SvgPlantBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C8E6C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 24l3.346-3.345a6.366 6.366 0 004.13 1.504 6.451 6.451 0 005.132-2.566A10.796 10.796 0 0024 13.156V8h-5.156c-2.32.005-4.578.757-6.437 2.145a6.447 6.447 0 00-2.566 5.135 6.367 6.367 0 001.504 4.13L8 22.75 9.25 24zm2.36-8.723a4.647 4.647 0 011.859-3.716 8.959 8.959 0 015.374-1.791h3.387v3.386a8.96 8.96 0 01-1.79 5.375 4.64 4.64 0 01-6.582.864l4.903-4.905-1.25-1.251-4.906 4.906a4.643 4.643 0 01-.995-2.865v-.003z",
    fill: "#27272A"
  })));
};

export default SvgPlantBadge;